import { selectLogoImage, selectProfile } from '../../../../../store/workspace/selectors';
import { LeaveIcon, LockAltIcon, PencilIcon } from '../../../../../assets/icons';
import { useDispatch, useSelector } from '../../../../../store/store';
import InfoField from '../../components/InfoField';
import styles from './style.module.scss';
import {
    setEditEmailModal,
    setChangePasswordModal,
    setEditPhoneNumberModal,
    setEditAccountInfoModal,
    setEditCompanyInfoModal,
    setConfirmLeaveOrganizationModal,
} from '../../../../../store/workspace/slice';

/** Personal details and company details of the signed in user. */
function AccountInformation() {
    const dispatch = useDispatch();
    const logo = useSelector(selectLogoImage);
    const profile = useSelector(selectProfile);
    const isOwner = profile?.userRole === 'owner';

    return (
        <div className={styles.account}>
            <span className={styles.account_title}>Account Information</span>

            <div className={styles.basic_info}>
                {profile?.userRole === 'member' && <div className={styles.basic_info_member}>
                    <span>Member account</span>
                    <div
                        className={styles.basic_info_member_action}
                        onClick={() => dispatch(setConfirmLeaveOrganizationModal(true))}
                    >
                        <span>Leave organization</span>
                        <LeaveIcon />
                    </div>
                </div>}

                <div className={styles.basic_info_header}>
                    <span>Title: </span>
                    {isOwner && <PencilIcon onClick={() => dispatch(setEditAccountInfoModal(true))} />}
                </div>
                <b>{profile?.employerRole?.title}</b>

                <div className={styles.basic_info_content}>
                    <div className={styles.basic_info_content_item}>
                        <InfoField label='First name' value={profile?.firstName} />
                    </div>
                    <div className={styles.basic_info_content_item}>
                        <InfoField label='Last name' value={profile?.lastName} />
                    </div>
                    <div className={styles.basic_info_content_item}>
                        <InfoField label='Phone number' value={profile?.phoneNumber || '----'} />
                        {isOwner && <PencilIcon onClick={() => dispatch(setEditPhoneNumberModal(true))} />}
                    </div>
                    <div className={styles.basic_info_content_item}>
                        <InfoField label='Email' value={profile?.email || '----'} />
                        {isOwner && <PencilIcon onClick={() => dispatch(setEditEmailModal(true))} />}
                    </div>
                </div>

                <div
                    className={styles.basic_info_change_password}
                    onClick={() => dispatch(setChangePasswordModal(true))}
                >
                    <LockAltIcon />
                    <span>Change Login Password</span>
                </div>
            </div>

            <div className={styles.company_info}>
                <div className={styles.company_info_header}>
                    <div className={styles.company_info_header_title}>
                        <span>Company name:</span>
                        <div className={styles.group}>
                            <div className={styles.group_logo}>
                                {logo
                                    ? <img src={logo} alt='' />
                                    : <span>{profile?.companyName?.slice(0, 1)}</span>}
                            </div>
                            <b className={styles.group_name}>{profile?.companyName}</b>
                        </div>
                    </div>
                    {isOwner && <PencilIcon onClick={() => dispatch(setEditCompanyInfoModal(true))} />}
                </div>

                <div className={styles.company_info_detail}>
                    <div className={styles.company_info_detail_item}>
                        <InfoField label='Company website' value={profile?.companyWebsite} />
                    </div>
                    <div className={styles.company_info_detail_item}>
                        <InfoField label='Company size' value={profile?.companySize?.title} />
                    </div>
                </div>

                <div className={styles.company_info_extra}>
                    <div className={styles.company_info_extra_address}>
                        <InfoField bulleted label='Address' value={profile?.address} />
                    </div>
                    <div className={styles.company_info_extra_location}>
                        <InfoField bulleted label='City' value={profile?.city} />
                        <InfoField bulleted label='State' value={profile?.state} />
                        <InfoField bulleted label='Country' value={profile?.country} />
                        <InfoField bulleted label='Zip code' value={profile?.zipCode} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AccountInformation;
